module.exports = __webpack_public_path__ + "static/navLogo-9f4638bd1776183e6e39705cb1f961f2.png";